import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";

export function Placeholder({
  title,
  note,
}: {
  title?: string;
  note?: string;
}) {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t("error.notFoundTitle");
  const resolvedNote = note ?? t("error.notFoundSubtitle");

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-extrabold text-ink-1">{resolvedTitle}</h1>
      <Card>
        <div className="grid place-items-center px-6 py-16 text-center">
          <div className="grid h-16 w-16 place-items-center rounded-card bg-primary/10 text-primary">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h2 className="mt-3 text-base font-bold text-ink-1">{resolvedTitle}</h2>
          {resolvedNote && (
            <p className="mt-1 max-w-sm text-[13px] text-ink-3">{resolvedNote}</p>
          )}
          <Link to="/" className="mt-4 inline-block">
            <Button>{t("error.goHome")}</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
